export const CERVICAL_EXAM_ROOT_LINK_ID = "cervix";

export const CERVICAL_EXAM_DATE_TIME_LINK_ID = "cervixDateTime";
export const CERVICAL_EXAM_DATE_LINK_ID = "cervixDate";
export const CERVICAL_EXAM_TIME_LINK_ID = "cervixTime";

export const CERVICAL_EXAM_DILATION_LINK_ID = "cervixDilation";
export const CERVICAL_EXAM_EFFACEMENT_LINK_ID = "cervixEffacement";
export const CERVICAL_EXAM_STATION_LINK_ID = "cervixStation";
export const CERVICAL_EXAM_CONSISTENCY_LINK_ID = "cervixConsistency";
export const CERVICAL_EXAM_LOCATION_LINK_ID = "cervixLocationOfCervix";
export const CERVICAL_EXAM_FETAL_PRESENTATION_LINK_ID = "cervixFetalPresentation";
export const CERVICAL_EXAM_ACTIVE_LABOR_LINK_ID = "cervixActiveLabor";
export const CERVICAL_EXAM_NOTES_LINK_ID = "cervixNotes";
export const CERVICAL_EXAM_SIGNATURE_INITIALS_LINK_ID = "cervixSignatureInitials";

export const CERVICAL_EXAM_QUESTIONNAIRE_NAME = "cervical_exam";
